/**
 * Only use this if you want to navigate off the SPA. If you want to navigate within the app, use usePush instead. This is a very anti-SPA function and should only be used when absolutely necessary, ie: external navigation, pages outside the SPA, switching hosts which requires reloading the SPA.
 */
export function navigateOffsite(to: string) {
  return window.location.assign(to);
}
